import { Feature } from '@ngb-frontend/shared/types'

import { defaultOperationTime } from '../countries/defaults'

import type {
  CountryDateRulesProfile,
  OperatingHoursConfig,
  ServiceOptionValue,
} from '@ngb-frontend/shared/types'

/**
 * Business-defined min/max hours (or fixed slots) for the selected services.
 * The journey's table wins over the country's `any` table; the first entry
 * whose service is selected decides the window.
 */
export const resolveOperatingHours = (
  profile: CountryDateRulesProfile,
  services: ServiceOptionValue[],
  journey: Feature = Feature.MnR,
): OperatingHoursConfig => {
  if (!services.length) return defaultOperationTime

  const table =
    profile.operatingHours[journey] || profile.operatingHours.any || []

  return (
    table.find((window) => services.includes(window.type))?.time ||
    defaultOperationTime
  )
}
